import type { PropsWithChildren } from "react";
import { createGlobalStyle } from "styled-components";

import BuyNowBanner from "./BuyNowBanner";

type Props = PropsWithChildren<{
  message: string;
}>;

export default function WithLicenseBanner({ message: bannerText, children }: Props) {
  return (
    <>
      <BodyGlobalStyle />
      <BuyNowBanner text={bannerText} />
      {children}
    </>
  );
}

const BodyGlobalStyle = createGlobalStyle`
  body {
    color: var(--primary-text-color);
    font-family: var(--font-family);
  }
`;
